var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    _vm._b(
      {
        ref: "root",
        staticClass: "accordion",
        class: {
          "accordion-disable-expanded-borders": _vm.disableExpandedBorders,
        },
      },
      "div",
      _vm.oneAtTime && _vm.accordionId ? { id: _vm.accordionId } : {},
      false
    ),
    _vm._l(_vm.cards, function (card, index) {
      return _c(
        "div",
        { key: index, class: _vm.classes },
        [
          _c(
            _vm.elementType,
            { tag: "component", staticClass: "card-header" },
            [
              _vm.isLinkTitle
                ? _c(
                    "a",
                    {
                      attrs: {
                        id: card.headingId,
                        role: "button",
                        href: "#" + card.collapseId,
                        "data-bs-toggle": "collapse",
                        "data-bs-target": "#" + card.collapseId,
                        "aria-controls": "#" + card.collapseId,
                        "aria-expanded": card.expanded,
                      },
                    },
                    [
                      _c("span", { staticClass: "accordion-card-title" }, [
                        _c("span", { staticClass: "accordion-title" }, [
                          _vm._v(_vm._s(card.title)),
                        ]),
                        _vm._v(" "),
                        _c("span", {
                          staticClass: "accordion-icon",
                          attrs: { "aria-hidden": "true" },
                        }),
                      ]),
                    ]
                  )
                : _c(
                    "button",
                    _vm._b(
                      {
                        class: card.expanded ? "show" : "collapsed",
                        attrs: {
                          id: card.headingId,
                          "data-bs-toggle": "collapse",
                          "data-bs-target": "#" + card.collapseId,
                          "aria-controls": "#" + card.collapseId,
                          "aria-expanded": card.expanded,
                          type: "button",
                        },
                      },
                      "button",
                      _vm.isDisabled ? { disabled: "" } : {},
                      false
                    ),
                    [
                      _c(
                        "span",
                        {
                          staticClass: "accordion-card-title",
                          class: _vm.isLarge ? "ob1-accordion-large" : "",
                        },
                        [
                          card.icon
                            ? _c("span", {
                                class: "item-icon " + card.icon,
                                attrs: { "aria-hidden": "true" },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("span", { staticClass: "accordion-title" }, [
                            _vm._v(_vm._s(card.title)),
                          ]),
                          _vm._v(" "),
                          _c("span", {
                            staticClass: "accordion-icon",
                            attrs: { "aria-hidden": "true" },
                          }),
                        ]
                      ),
                    ]
                  ),
            ]
          ),
          _vm._v(" "),
          _c(
            "section",
            _vm._b(
              {
                staticClass: "collapse",
                class: card.expanded ? "show" : "",
                attrs: {
                  id: card.collapseId,
                  "aria-labelledby": card.headingId,
                },
              },
              "section",
              _vm.oneAtTime && _vm.accordionId
                ? { "data-bs-parent": "#" + _vm.accordionId }
                : {},
              false
            ),
            [_vm._t(card.headingId)],
            2
          ),
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }